export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/three_essentials_bg-c6760498f59c862138edcad11fde9c1c.svg";